import { pushDataLayer } from '../index'
import { PageViewLayer } from '@component/dataLayer'

export default function PageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'vertical': 'new homes',
      'vertical_type': 'home builders',
      'page_type': 'search',
      'event': 'page_view'
    }}></PageViewLayer>
  )
}

export function BuilderDetailPageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'vertical': 'new homes',
      'vertical_type': 'home builders',
      'page_type': 'detail',
      'event': 'page_view'
    }}></PageViewLayer>
  )
}

export const searchDataLayer = {
  search() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Search',
      'event_interaction': 'CTA',
      'event_type': 'new home'
    })
  }
}